module.exports = __webpack_public_path__ + "img/aboutadjuz6.6da4c114.png";